import { render, staticRenderFns } from "./cash-paid-info.vue?vue&type=template&id=0bbfc76e"
import script from "./cash-paid-info.vue?vue&type=script&lang=ts"
export * from "./cash-paid-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports